import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCardText,
  CCardTitle,
  CCol,
  CContainer,
  CForm,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CInputGroup,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


import { faArrowUpFromGroundWater } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const LandingPage = () => {
  const [loanAmount, setLoanAmount] = useState('');
  const [interestRate, setInterestRate] = useState('');
  const [years, setYears] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [customEMI, setCustomEMI] = useState('');
  const [enableAdditionalRepayment, setEnableAdditionalRepayment] = useState(false);
  // const [submitted, setSubmitted] = useState(false);
  const [emiDataTable, setEmiDataTable] = useState([]);
  const [emiData, setEmiData] = useState({ data: [], totalInterest: 0, totalAdditionalRepayment: 0, savingsInterest: 0, reducedMonths: 0, totalEMI: 0, increasedEMIMonths: 0 });
  const [additionalRepayments, setAdditionalRepayments] = useState({});
  const [additionalRepaymentDates, setAdditionalRepaymentDates] = useState({});
  // const [totalInterestWithoutRepayment, setTotalInterestWithoutRepayment] = useState(null);
  const topCardRef = useRef(null);

  // State for checkboxes
  const [roundUpEMIChecked, setRoundUpEMIChecked] = useState(false);
  const [extraEMIChecked, setExtraEMIChecked] = useState(false);
  const [extraYearlyEMIChecked, setExtraYearlyEMIChecked] = useState(false);


  const phoneNumber = '919789411663';
  // Check if the user is on a mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Set the appropriate WhatsApp link based on the platform
  const whatsappLink = isMobile
    ? `whatsapp://send/?phone=${phoneNumber}`
    : `https://web.whatsapp.com/send?phone=${phoneNumber}`;


  const scrollToTop = () => {
    if (topCardRef.current) {
      topCardRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const handleAdditionalRepaymentChange = (index, value) => {
    if (enableAdditionalRepayment) {
      setAdditionalRepayments({
        ...additionalRepayments,
        [index]: Number(value),
      });
    }
  };

  const handleRepaymentDateChange = (index, date) => {
    if (enableAdditionalRepayment) {
      setAdditionalRepaymentDates({
        ...additionalRepaymentDates,
        [index]: date,
      });
      // Scroll to top card
      if (topCardRef.current) {
        topCardRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  const calculateEMIBreakdown = () => {
    let balance = Number(loanAmount);
    const monthlyInterestRate = Number(interestRate) / 12 / 100;
    let totalInterest = 0;
    let totalEMI = 0;
    let totalAdditionalRepayment = 0;
    let savingsInterest = 0;
    let reducedMonths = 0;
    let actualMonths = 0;

    let previousTotalInterest = 0;  // Store unrounded total interest here
    //  let currentTotalInterest = 0;   // Store rounded total interest here

    const data = [];
    const emiStartMonth = startDate.getMonth();
    const emiStartYear = startDate.getFullYear();

    // Calculate the total interest without additional repayments (unrounded)
    let tempBalance = Number(loanAmount);

    for (let i = 1; i <= Number(years * 12); i++) {
      const monthInterestWithoutRepayment = tempBalance * monthlyInterestRate;
      const emiWithoutRepayment = calculateEMI(loanAmount, interestRate, years * 12);

      // Update the balance and interest for the unrounded case
      tempBalance = Math.max(tempBalance - (emiWithoutRepayment - monthInterestWithoutRepayment), 0);
      previousTotalInterest += monthInterestWithoutRepayment;  // Accumulate interest without rounding

      if (tempBalance === 0) break;
    }

    // Reset balance for the actual repayment calculation
    balance = Number(loanAmount);

    // Calculate EMI breakdown with additional repayments and potential rounding
    for (let i = 1; i <= Number(years * 12); i++) {
      let monthInterest = 0;
      let remainingBalCal = 0;
      let additionalRepayment = additionalRepayments[i] || 0;
      const actualEMIcalc = calculateEMI(loanAmount, interestRate, years * 12);  // Regular EMI calculation

      const currentMonth = (startDate.getMonth() + i - 1) % 12;
      const currentYear = startDate.getFullYear() + Math.floor((startDate.getMonth() + i - 1) / 12);

      // Calculate EMI after rounding (if `roundUpEMIChecked` is selected)
      let actualEMIValue = roundUpEMIChecked
        ? roundToNearest1000(actualEMIcalc)  // Round only the EMI, not the interest
        : actualEMIcalc;

      let isDoubled = false;
      let doubledEMIDisplay = '';

      // Apply twice EMI logic if needed
      if (extraYearlyEMIChecked && currentMonth === emiStartMonth && (currentYear - emiStartYear) >= 0) {
        actualEMIValue *= 2;
        isDoubled = true;
        doubledEMIDisplay = `${actualEMIValue / 2} + ${actualEMIValue / 2}`;
      }

      const customEMIValue = extraEMIChecked ? Number(customEMI) || 0 : 0;
      let emiForThisMonth = actualEMIValue + customEMIValue;

      const repaymentDate = additionalRepaymentDates[i];
      const daysInMonth = new Date(startDate.getFullYear(), startDate.getMonth() + i, 0).getDate();

      if (repaymentDate) {
        const repaymentDay = new Date(repaymentDate).getDate();

        // Interest up to the repayment date
        const interestUntilRepayment = balance * (monthlyInterestRate / daysInMonth) * repaymentDay;

        // Update the balance after additional repayment
        //balance -= additionalRepayment;
        let newbalance = balance - additionalRepayment;

        // Recalculate the interest for the remaining days after repayment
        const interestAfterRepayment = newbalance * (monthlyInterestRate / daysInMonth) * (daysInMonth - repaymentDay);
        monthInterest = interestUntilRepayment + interestAfterRepayment;
      } else {


        // Calculate interest based on the current balance, regardless of EMI rounding
        monthInterest = balance * monthlyInterestRate;
      }


      // Cap EMI to avoid overpayment
      if (emiForThisMonth > balance + monthInterest) {
        emiForThisMonth = balance + monthInterest;
      }

      // Handle additional repayments logic
      if (repaymentDate) {
        remainingBalCal = (balance - additionalRepayment) - (emiForThisMonth - monthInterest);
      } else {
        remainingBalCal = balance - (emiForThisMonth - monthInterest);
      }

      let remainingBalance = Math.round(remainingBalCal);
      if (remainingBalance < 0) remainingBalance = 0;

      // Update the total interest and balance
      totalInterest += monthInterest;  // Always accumulate correct interest
      totalAdditionalRepayment += Math.round(additionalRepayment);
      totalEMI += Math.round(emiForThisMonth);

      const monthYear = new Date(startDate);
      monthYear.setMonth(monthYear.getMonth() + i - 1);
      actualMonths = Number(years * 12) || 0;

      const emiColor = roundUpEMIChecked ? '#1acdb6' : extraEMIChecked ? '#e8a6f1' : 'transparent';

      data.push({
        emiNumber: i,
        monthYear,
        openingBalance: Math.round(balance),
        interest: Math.round(monthInterest),
        totalBalance: Math.round(balance + monthInterest),
        actualEMI: Math.round(actualEMIValue),
        customEMI: Math.round(customEMIValue),
        sumofEMI: Math.round(emiForThisMonth),
        additionalRepayment: additionalRepayment === 0 ? '' : Math.round(additionalRepayment),
        additionalRepaymentDate: additionalRepaymentDates[i] || '',
        remainingBalance: Math.round(remainingBalance),
        isDoubled,
        doubledEMIDisplay,
        emiColor // Store the color
      });

      if (remainingBalance === 0 && reducedMonths === 0) {
        reducedMonths = i;
      }
      balance = remainingBalance;
    }

    // Calculate the savings interest by comparing the total interest
    savingsInterest = previousTotalInterest
      ? Math.round(previousTotalInterest) - Math.round(totalInterest)
      : 0;


    return {
      data,
      totalInterest: Math.round(totalInterest),
      totalAdditionalRepayment,
      savingsInterest,
      actualMonths,
      reducedMonths,
      totalEMI: Math.round(totalEMI)
    };
  };


  // Handle change for all checkboxes
  const handleCheckBoxChange = (e) => {
    const { id, checked } = e.target;
    if (id === 'roundUpEMI') {
      setRoundUpEMIChecked(checked);
    } else if (id === 'extraEMI') {
      setExtraEMIChecked(checked);
    } else if (id === 'oneExtraEMI') {
      setExtraYearlyEMIChecked(checked);
    }
  };
  const handleClearAdditionalRepayment = (index) => {
    setAdditionalRepayments(prev => ({ ...prev, [index]: '' }));
    handleRepaymentDateChange(index, null);
    //setTotalInterestWithoutRepayment(null);
  };


  const calculateEMI = (loanAmount, interestRate, months) => {
    if (loanAmount === 0 || interestRate === 0 || months === 0) return 0;
    const monthlyInterestRate = interestRate / 12 / 100;
    return Math.round(
      loanAmount * monthlyInterestRate *
      Math.pow(1 + monthlyInterestRate, months) /
      (Math.pow(1 + monthlyInterestRate, months) - 1)
    );
  };
  const roundToNearest1000 = (value) => {
    return Math.ceil(value / 1000) * 1000;
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    const result = calculateEMIBreakdown();
    setEmiData(result);
    setEmiDataTable(result.data);
  };

  const resetClick = () => {
    setLoanAmount('');
    setInterestRate('');
    setYears('');
    setStartDate(new Date());
    setCustomEMI('');
    setEnableAdditionalRepayment(false);
    // setSubmitted(false);
    setEmiData({ data: [], totalInterest: 0, totalAdditionalRepayment: 0, savingsInterest: 0, reducedMonths: 0, totalEMI: 0, emiColor: '' });
    setEmiDataTable([]);
    setAdditionalRepayments({});
    setAdditionalRepaymentDates({});
    //setTotalInterestWithoutRepayment(null);
  };

  // const handleEMIChange = (index, value) => {
  //   setEmiDataTable(prevEmiDataTable => {
  //     const updatedEMIData = [...prevEmiDataTable];
  //     updatedEMIData[index].sumofEMI = Number(value);

  //     // Initialize variables to calculate totals
  //     let totalInterest = 0;
  //     let totalAdditionalRepayment = 0;
  //     let savingsInterest = 0;
  //     let reducedMonths = 0;
  //     let totalEMI = 0; // Total of all EMIs
  //     const data = []; // To hold the EMI breakdown data

  //     // If EMI is set to 0, handle it accordingly
  //     if (Number(value) === 0) {
  //       updatedEMIData[index].remainingBalance = updatedEMIData[index].totalBalance;

  //       // Update opening balances for subsequent months
  //       for (let i = index + 1; i < updatedEMIData.length; i++) {
  //         updatedEMIData[i].openingBalance = updatedEMIData[i - 1].remainingBalance;
  //         updatedEMIData[i].totalBalance = updatedEMIData[i].openingBalance + updatedEMIData[i].interest;
  //         updatedEMIData[i].remainingBalance = updatedEMIData[i].totalBalance - updatedEMIData[i].sumofEMI;
  //       }

  //       // Always add a new EMI row when an EMI is set to 0
  //       const lastRow = updatedEMIData[updatedEMIData.length - 1];
  //       const nextMonthYear = new Date(lastRow.monthYear);
  //       nextMonthYear.setMonth(nextMonthYear.getMonth() + 1);

  //       const newRow = {
  //         emiNumber: updatedEMIData.length + 1,
  //         monthYear: nextMonthYear,
  //         openingBalance: lastRow.remainingBalance,
  //         interest: 0,
  //         totalBalance: lastRow.remainingBalance,
  //         actualEMI: 0,
  //         customEMI: 0,
  //         sumofEMI: 0,
  //         additionalRepayment: '',
  //         additionalRepaymentDate: '',
  //         remainingBalance: lastRow.remainingBalance,
  //       };

  //       updatedEMIData.push(newRow);
  //     } else {
  //       // If EMI is not 0, calculate remaining balance as before
  //       updatedEMIData[index].remainingBalance = updatedEMIData[index].totalBalance - Number(value);

  //       // Update opening balances for subsequent months
  //       for (let i = index + 1; i < updatedEMIData.length; i++) {
  //         updatedEMIData[i].openingBalance = updatedEMIData[i - 1].remainingBalance;
  //         updatedEMIData[i].totalBalance = updatedEMIData[i].openingBalance + updatedEMIData[i].interest;
  //         updatedEMIData[i].remainingBalance = updatedEMIData[i].totalBalance - updatedEMIData[i].sumofEMI;
  //       }
  //     }

  //     // Calculate the new EMI breakdown
  //     for (let i = 0; i < updatedEMIData.length; i++) {
  //       const currentRow = updatedEMIData[i];
  //       totalInterest += Math.round(currentRow.interest);
  //       totalAdditionalRepayment += Number(currentRow.additionalRepayment) || 0;
  //       totalEMI += Math.round(currentRow.sumofEMI); // Accumulate total EMI

  //       // Add row data to the data array
  //       data.push({
  //         emiNumber: currentRow.emiNumber,
  //         monthYear: currentRow.monthYear,
  //         openingBalance: Math.round(currentRow.openingBalance),
  //         interest: Math.round(currentRow.interest),
  //         totalBalance: Math.round(currentRow.totalBalance),
  //         actualEMI: Math.round(currentRow.actualEMI),
  //         customEMI: Math.round(currentRow.customEMI),
  //         sumofEMI: Math.round(currentRow.sumofEMI),
  //         additionalRepayment: Math.round(Number(currentRow.additionalRepayment) || 0),
  //         additionalRepaymentDate: currentRow.additionalRepaymentDate,
  //         remainingBalance: Math.round(currentRow.remainingBalance),
  //       });

  //       // Determine the reduced months (if the balance reaches 0)
  //       if (currentRow.remainingBalance === 0 && reducedMonths === 0) {
  //         reducedMonths = i + 1; // 1-based month index
  //       }
  //     }

  //     // Calculate savings interest
  //     savingsInterest = Math.round(totalInterestWithoutRepayment - totalInterest);

  //     // Set the EMI data state with all required values
  //     setEmiData({
  //       data, // The breakdown data
  //       totalInterest: Math.round(totalInterest),
  //       totalAdditionalRepayment: Math.round(totalAdditionalRepayment),
  //       savingsInterest: Math.round(savingsInterest),
  //       reducedMonths,
  //       totalEMI: Math.round(totalEMI),
  //       increasedEMIMonths: updatedEMIData.length,
  //     });

  //     return updatedEMIData;
  //   });
  // };


  useEffect(() => {
    if (!enableAdditionalRepayment) {
      setAdditionalRepayments({});
      setAdditionalRepaymentDates({});
    }
  }, [enableAdditionalRepayment]);

  const formatINR = (amount) => {
    //if (amount === 0) return ''; // Return an empty string or a placeholder for 0
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0, // Removes '.00' for whole numbers
      maximumFractionDigits: 2 // Allows up to two decimal places for fractional amounts
    }).format(amount);
  };

  const additionRepaymentNoFunction = () => {
    setEnableAdditionalRepayment(false);
    setExtraEMIChecked(false);
    setExtraYearlyEMIChecked(false);
    setRoundUpEMIChecked(false);
  }

  return (
    <CContainer className="py-4">
      <CRow className="justify-content-center">
        <CCol xs={12} lg={12} xl={12}>
          <CRow >
            <CCol xs={12} md={6} className="mb-4">
              <CCard className="h-100 shadow">
                <CCardHeader as="h5" className="cardhbg" ref={topCardRef}>Loan Calculator</CCardHeader>
                <CForm onSubmit={handleSubmit}>
                  <CCardBody className="m-2">
                    <CRow className="mb-3">
                      <CCol md={4}>
                        <CFormLabel className="label-control">Loan Amount</CFormLabel>
                      </CCol>
                      <CCol md={8}>
                        <CFormInput type="number" value={loanAmount} placeholder="Enter Loan Amount"
                          onChange={(e) => {
                            const value = Number(e.target.value);
                            setLoanAmount(value > 0 ? value : '');
                          }} required min="1" />
                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol md={4}>
                        <CFormLabel className="label-control">Interest Rate (%)</CFormLabel>
                      </CCol>
                      <CCol md={8}>
                        <CFormInput
                          type="text"
                          value={interestRate}
                          placeholder="Enter Interest Rate"
                          onChange={(e) => {
                            const value = e.target.value;

                            // Regex to allow numbers with optional decimals
                            const isValid = /^\d*\.?\d*$/.test(value);

                            if (isValid) {
                              setInterestRate(value);
                            }
                          }}
                          required
                        />

                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol md={4}>
                        <CFormLabel className="label-control">Loan Duration(Years)</CFormLabel>
                      </CCol>
                      <CCol md={8}>
                        <CFormInput type="number" value={years} placeholder="Enter Loan Duration in Years"
                          onChange={(e) => {
                            const value = Number(e.target.value);
                            setYears(value > 0 ? value : '');
                          }} required min="1" />
                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol md={4}>
                        <CFormLabel className="label-control">EMI Starts On</CFormLabel>
                      </CCol>
                      <CCol md={8}>
                        <DatePicker selected={startDate} onChange={(date) => setStartDate(date)}
                          dateFormat="MMMM yyyy" showMonthYearPicker placeholderText="Select Start Month" className="form-control w-100" required
                        />
                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol md={8} xs={12}>
                        <CFormLabel className="label-control">Can You Pay Additional Amount with EMI?</CFormLabel>
                      </CCol>
                      <CCol md={4} xs={12} className="pt-1">
                        <CFormCheck
                          type="radio"
                          id="additionalRepaymentYes"
                          label={<span className="green-text">Yes</span>}
                          onChange={() => setEnableAdditionalRepayment(true)}
                          checked={enableAdditionalRepayment}
                          style={{ border: '1px solid black', backgroundColor: enableAdditionalRepayment ? 'black' : '' }}
                          inline
                        />
                        <CFormCheck
                          type="radio" className="mx-2"
                          id="additionalRepaymentNo" style={{ border: '1px solid black', backgroundColor: !enableAdditionalRepayment ? 'black' : '' }}
                          label={<span className="red-text">No</span>}
                          onChange={() => additionRepaymentNoFunction()}
                          checked={!enableAdditionalRepayment}
                          inline
                        />
                      </CCol>
                    </CRow>
                    {enableAdditionalRepayment && (
                      <CRow>
                        <CCol xs={12} className="d-flex flex-column align-items-start mb-2">
                          <CFormCheck
                            id="roundUpEMI"
                            label="Roundup my EMI to Nearest Thousand"
                            className="mb-2 roundUpEMI"
                            checked={roundUpEMIChecked}
                            onChange={handleCheckBoxChange}
                          />
                        </CCol>

                        <CCol xs={12} className="d-flex flex-column align-items-start mb-2">
                          <div className="d-flex align-items-center mb-2">
                            <CFormCheck
                              id="extraEMI"
                              label="I Can Pay" className='extraEMI'
                              checked={extraEMIChecked}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                handleCheckBoxChange(e);
                                if (!isChecked) {
                                  setCustomEMI('');  // Reset input when unchecked
                                }
                              }}
                            />
                            <CInputGroup style={{ width: '130px', marginLeft: '10px' }} className="my-2">
                              <CFormInput
                                type="number"
                                value={customEMI}
                                placeholder=""
                                min="1"
                                onChange={(e) => {
                                  const value = Number(e.target.value);
                                  setCustomEMI(value > 0 ? value : '');
                                }}
                              />
                            </CInputGroup>
                            <span className="mx-2">With EMI Every Month</span>
                          </div>

                        </CCol>

                        <CCol xs={12} className="d-flex flex-column align-items-start mb-2">
                          <CFormCheck
                            id="oneExtraEMI"
                            label="I Can Pay One Extra EMI Every Year"
                            className="mb-3 oneExtraEMI"
                            checked={extraYearlyEMIChecked}
                            onChange={handleCheckBoxChange}
                          />
                        </CCol>
                      </CRow>
                    )}

                  </CCardBody>

                  <CCardFooter className={!enableAdditionalRepayment ? "cardfbg mt-5" : "cardfbg"}>
                    <CButton className="btn-design mx-3" type="submit">
                      Calculate
                    </CButton>
                    <CButton className="reset-design" color="secondary" onClick={resetClick}>
                      Reset
                    </CButton>
                  </CCardFooter>
                </CForm>
              </CCard>
            </CCol>
            <CCol xs={12} md={6} className="mb-4">
              <CCard className="h-100 shadow">
                <CCardHeader as="h5" className='cardhbg' ref={topCardRef}>Loan Summary</CCardHeader>
                <CCardBody className="m-2">
                  <CRow className="m-0 text-center">
                    {/* Align Loan Amount, Monthly EMI, and Total Interest in one row */}
                    <CCol md={12} xs={12} className="summary-item">
                      <strong>Loan Amount</strong>
                      <h3 className="blue-text pt-1">{formatINR(loanAmount)}</h3>
                    </CCol>
                    <CCol md={12} xs={12} className="summary-item">
                      <strong>Monthly EMI</strong>
                      <h3 className="blue-text pt-1">{emiDataTable.length > 0 ? formatINR(emiDataTable[1].actualEMI) : '0.00'}</h3>
                    </CCol>
                    <CCol md={12} xs={12} className="summary-item">
                      <strong>Total Interest</strong>
                      <h3 className="blue-text pt-1">{formatINR(emiData.totalInterest)}</h3>
                    </CCol>
                    {emiData.savingsInterest > 0 && (emiData.actualMonths !== emiData.reducedMonths) && (<>
                      <CCardTitle className="h3 mt-3 mb-4" style={{ color: "green" }}>Wow!</CCardTitle>

                      <CCol md={6} className="green-background">
                        <CCardText className="mb-2 mt-4 summary-text">You are saving</CCardText>
                        <CCardText className="green-text mb-2 h1 fw-bold">{formatINR(emiData.savingsInterest)}</CCardText>
                        <CCardText className="mb-4 summary-text">on Interest</CCardText>
                        <CCardText className="mb-3 summary-text">Your total interest comes down from</CCardText>
                        <CCardText className="mb-4 h3">
                          <span className="blue-text">{formatINR(emiData.savingsInterest + emiData.totalInterest) || '0.00'}</span>
                          <span className='green-text'> to </span>
                          <span className="blue-text">{formatINR(emiData.totalInterest) || '0.00'}</span>
                        </CCardText>
                      </CCol>
                      <CCol md={6} className="green-background">
                        <CCardText className="mb-2 mt-4 summary-text">You are saving</CCardText>
                        <CCardText className="green-text mb-2 h1 fw-bold">
                          {(emiData.actualMonths || 0) - (emiData.reducedMonths || 0)}
                        </CCardText>
                        <CCardText className="mb-4 summary-text">EMI months</CCardText>
                        <CCardText className="mb-3 summary-text"> Your EMI duration comes down from</CCardText>
                        <CCardText className="mb-4 h3">
                          <span className="blue-text">{emiData.actualMonths || 0}</span>
                          <span className='green-text'> to </span>
                          <span className="blue-text">{emiData.reducedMonths}</span>
                        </CCardText>
                      </CCol>
                    </>
                    )}
                    {/* {emiData.savingsInterest < 0 && (
                      <>
                        <CCardTitle className="h3 mt-3 mb-4" style={{ color: "red" }}>Oops!</CCardTitle>

                        <CCol md={6} className="red-background">
                          <CCardText className="mb-2 mt-4 summary-text">You are paying extra</CCardText>
                          <CCardText className="red-text mb-2 h1 fw-bold">
                            {formatINR(emiData.totalInterest + emiData.savingsInterest)}
                          </CCardText>
                          <CCardText className="mb-4 summary-text">on Interest</CCardText>
                          <CCardText className="mb-3 summary-text">Your total interest goes up from</CCardText>
                          <CCardText className="mb-4 h3">
                            <span className="blue-text">{formatINR(totalInterestWithoutRepayment) || '0.00'}</span>
                            <span className='red-text'> to </span>
                            <span className="blue-text">{formatINR(emiData.totalInterest) || '0.00'}</span>
                          </CCardText>
                        </CCol>
                        <CCol md={6} className="red-background">

                          <CCardText className="mb-2 mt-4 summary-text">You are paying extra</CCardText>
                          <CCardText className="red-text mb-2 h1 fw-bold">
                            {(emiData.increasedEMIMonths || 0) - (emiData.actualMonths || 0)}
                          </CCardText>
                          <CCardText className="mb-4 summary-text">EMI months</CCardText>
                          <CCardText className="mb-3 summary-text">Your EMI duration goes up from  </CCardText>
                          <CCardText className="mb-4 h3">
                            <span className="blue-text">{emiData.actualMonths || 0}</span>
                            <span className='red-text'> to </span>
                            <span className="blue-text">{emiData.increasedEMIMonths || 0}</span>
                          </CCardText>
                        </CCol>
                      </>
                    )} */}
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>

          </CRow>
        </CCol>
        <CCol xs={12}>
          <CCard className="shadow">
            <CCardHeader as="h5" className="cardhbg">EMI Breakdown</CCardHeader>
            <CCardBody>
              <div className="table-responsive ">
                <CTable striped bordered hover className="emi-table" responsive>
                  <CTableHead>
                    <CTableRow color="info">
                      <CTableHeaderCell className="align-middle">EMI No</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Month/Year</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Opening Balance</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Interest</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Total Balance</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Actual EMI</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Custom EMI</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Total EMI</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Additional Repayment</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Repayment Date</CTableHeaderCell>
                      <CTableHeaderCell className="align-middle">Remaining Balance</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  {emiDataTable.length > 0 ? (
                    <CTableBody>
                      {emiDataTable.map((row, index) => (
                        <CTableRow key={index} className={emiData.reducedMonths !== 0 && (row.emiNumber - 1) >= emiData.reducedMonths ? 'selective-blur align-middle' : ''}>
                          <CTableDataCell className="align-middle">{row.emiNumber}</CTableDataCell>
                          <CTableDataCell className="align-middle">{row.monthYear.toLocaleString('en-US', { month: 'short', year: 'numeric' })}</CTableDataCell>
                          <CTableDataCell className="blur-cell align-middle">{formatINR(row.openingBalance)}</CTableDataCell>
                          <CTableDataCell className="blur-cell align-middle">{formatINR(row.interest)}</CTableDataCell>
                          <CTableDataCell className="blur-cell align-middle">{formatINR(row.totalBalance)}</CTableDataCell>
                          <CTableDataCell
                            className="blur-cell align-middle"
                            style={{ backgroundColor: row.isDoubled ? '#dce400' : row.emiColor === '#1acdb6' ? '#1acdb6' : 'transparent' }}
                          >
                            {formatINR(row.actualEMI)}
                            <div>
                              <small style={{ color: 'red', display: 'block' }}>{row.doubledEMIDisplay}</small>
                            </div>
                          </CTableDataCell>

                          <CTableDataCell className="blur-cell align-middle"
                            style={{ backgroundColor: row.emiColor === '#e8a6f1' ? '#e8a6f1' : 'transparent' }}>{formatINR(row.customEMI)}</CTableDataCell>
                          <CTableDataCell className="blur-cell align-middle">{row.sumofEMI}</CTableDataCell>
                          {/* <CTableDataCell className="blur-cell align-middle">
                            <CFormInput
                              type="number"
                              value={row.sumofEMI}
                              onChange={(e) => handleEMIChange(index, e.target.value)}
                              placeholder="Total EMI"
                              min="1"
                              className="hide-spinner w-100"
                              style={{ minWidth: '80px' }}
                            />
                          </CTableDataCell> */}
                          <CTableDataCell className="blur-cell">
                            <CFormInput
                              type="number"
                              value={additionalRepayments[index + 1] || ''}
                              onChange={(e) => {
                                const value = Number(e.target.value);
                                handleAdditionalRepaymentChange(index + 1, value);
                                if (e.target.value === '') {
                                  handleClearAdditionalRepayment(index + 1);
                                }
                              }}
                              placeholder="Amount"
                              min="1"
                              className="hide-spinner w-100"
                              style={{ minWidth: '80px' }}
                            />
                          </CTableDataCell>
                          <CTableDataCell className="blur-cell">
                            <DatePicker
                              selected={additionalRepaymentDates[index + 1] ? new Date(additionalRepaymentDates[index + 1]) : null}
                              onChange={(date) => handleRepaymentDateChange(index + 1, date)}
                              dateFormat="dd/MM/yyyy"
                              placeholderText={`DD/${row.monthYear.toLocaleString('en-US', { month: '2-digit' })}/${row.monthYear.getFullYear()}`}
                              minDate={new Date(row.monthYear.getFullYear(), row.monthYear.getMonth(), 1)}
                              maxDate={new Date(row.monthYear.getFullYear(), row.monthYear.getMonth() + 1, 0)}
                              isClearable
                              className="custom-form-input w-100"
                              style={{ minWidth: '120px' }}
                            />
                          </CTableDataCell>
                          <CTableDataCell className="blur-cell align-middle">{formatINR(row.remainingBalance)}</CTableDataCell>
                        </CTableRow>
                      ))}
                      <CTableRow color="warning">
                        <CTableHeaderCell>Total</CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                        <CTableHeaderCell>{formatINR(emiData.totalInterest) || 0}</CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                        <CTableHeaderCell>{formatINR(emiData.totalEMI) || 0}</CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                        <CTableHeaderCell></CTableHeaderCell>
                      </CTableRow>
                    </CTableBody>
                  ) : (
                    <CTableBody>
                      <CTableRow>
                        <CTableDataCell colSpan="11" className="pt-4 pb-4">
                          <div>
                            <h4>Please Enter the Loan details and click <strong>'Calculate'</strong> to compute your loan EMI Breakdown</h4>
                          </div>
                        </CTableDataCell>
                      </CTableRow>
                    </CTableBody>


                  )}
                </CTable>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
        {emiDataTable.length > 0 && (
          <CCardFooter className='mb-3 mt-3'>
            <CButton
              className="btn-design text-white"
              onClick={scrollToTop}>
              <FontAwesomeIcon icon={faArrowUpFromGroundWater} className="me-2" />
              Go to Top (Loan Calculator)
            </CButton>
          </CCardFooter>
        )}
      </CRow>
      <CRow>
        <CCol sm={12}>
          <CCardFooter className='footercls'>
            <h6>Powered By Bank Steps</h6>
            <h6 className="mb-0">
              For Feedback and Suggestions Whatsapp us at
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className='mx-2'
              >
                <FontAwesomeIcon icon={faWhatsapp} className='mx-2' /> Chat With Us
              </a>
            </h6>
          </CCardFooter>

        </CCol>
      </CRow>

    </CContainer>

  );
};

export default LandingPage;
